module.exports = __webpack_public_path__ + "img/erp2.fbbfe2e2.png";